import React from 'react';
const PaymentHistory = () => {
  return <div className="space-y-6" data-id="element-417">
      <div data-id="element-418">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-419">Payment History</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-420">
          View all your past payment transactions
        </p>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-421">
        <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-422">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-423">
            Transaction History
          </h3>
          <div className="flex items-center space-x-2" data-id="element-424">
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-425">
              <option data-id="element-426">Last 30 days</option>
              <option data-id="element-427">Last 90 days</option>
              <option data-id="element-428">Last 12 months</option>
              <option data-id="element-429">All time</option>
            </select>
          </div>
        </div>
        <div className="border-t border-gray-200" data-id="element-430">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-431">
            <thead className="bg-gray-50" data-id="element-432">
              <tr data-id="element-433">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-434">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-435">
                  Customer
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-436">
                  Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-437">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-438">
                  Reference
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-439">
              {[{
              id: 1,
              date: '2023-07-10',
              customer: 'Tech Solutions Inc.',
              amount: '$945.00',
              status: 'Completed',
              reference: 'INV-2023-001'
            }, {
              id: 2,
              date: '2023-07-08',
              customer: 'Innovate Ltd.',
              amount: '$1,876.50',
              status: 'Completed',
              reference: 'INV-2023-002'
            }, {
              id: 3,
              date: '2023-06-30',
              customer: 'Global Enterprises',
              amount: '$2,340.00',
              status: 'Completed',
              reference: 'INV-2023-003'
            }, {
              id: 4,
              date: '2023-06-22',
              customer: 'ABC Corporation',
              amount: '$1,245.00',
              status: 'Completed',
              reference: 'INV-2023-004'
            }, {
              id: 5,
              date: '2023-06-15',
              customer: 'XYZ Industries',
              amount: '$876.50',
              status: 'Completed',
              reference: 'INV-2023-005'
            }].map(transaction => <tr key={transaction.id} data-id="element-440">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-441">
                    {new Date(transaction.date).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-442">
                    {transaction.customer}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-443">
                    {transaction.amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-444">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-445">
                      {transaction.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-446">
                    {transaction.reference}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-447">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-448">
            <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-449">
              Previous
            </a>
            <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-450">
              Next
            </a>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-451">
            <div data-id="element-452">
              <p className="text-sm text-gray-700" data-id="element-453">
                Showing <span className="font-medium" data-id="element-454">1</span> to{' '}
                <span className="font-medium" data-id="element-455">5</span> of{' '}
                <span className="font-medium" data-id="element-456">12</span> results
              </p>
            </div>
            <div data-id="element-457">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-458">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-459">
                  <span className="sr-only" data-id="element-460">Previous</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-461">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-462" />
                  </svg>
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-463">
                  1
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-50 text-sm font-medium text-blue-600 hover:bg-blue-100" data-id="element-464">
                  2
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-465">
                  3
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-466">
                  <span className="sr-only" data-id="element-467">Next</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-468">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-469" />
                  </svg>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PaymentHistory;